import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Configuration} from '@shared/models/configuration';

@Injectable({
  providedIn: 'root'
})
export class AuditTrackerService {
  constructor(private httpClient: HttpClient) {
  }

  getAuditTypes() {
    return this.httpClient.get<any>(`${Configuration.getConfig('AuditTrackerApi')}AuditTracker/AuditTypes`);
  }

  getAuditStageTypes() {
    return this.httpClient.get<any>(`${Configuration.getConfig('AuditTrackerApi')}AuditTracker/AuditStageTypes`);
  }

  getFlowTemplates() {
    return this.httpClient.get<any>(`${Configuration.getConfig('AuditTrackerApi')}AuditTracker/FlowTemplates`);
  }
}
